import React, { PropTypes } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { FormattedMessage, intlShape } from "react-intl";

import MessageBox from "./MessageBox";
import { SelectInput } from "./form";

import { EnumWrapper } from "../../utils/enums";
import { LANGUAGE_CODES } from "../../utils/enums/enums";
import validationUtils from "../../utils/ValidationUtils";
let DOWNLOAD_VALIDATION_RULES = {
  languageCode: {
    isRequiredTrim: {
      value: true,
    },
  },
};

class DownloadForm extends React.Component {
  getChildContext() {
    return {
      scene: this.props.scene,
    };
  }

  render() {
    const { customFields } = this.props;

    return (
      <form onSubmit={this.props.handleSubmit}>
        {this.props.error && (
          <MessageBox key="coverageError" className="alert-danger">
            <FormattedMessage id={`download.errors.${this.props.error}`} />
          </MessageBox>
        )}

        <EnumWrapper enum={LANGUAGE_CODES} format="inputs" prop="options">
          <Field
            id="languageCode"
            name="languageCode"
            component={SelectInput}
            addBlankOption={true}
            label={<FormattedMessage id="download.form.languageCode" />}
          />
        </EnumWrapper>
        {customFields}
      </form>
    );
  }
}

DownloadForm.propTypes = {
  additionalValidation: PropTypes.object,
  customFields: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  error: PropTypes.string,
  scene: PropTypes.string,
  validation: PropTypes.object,
  handleSubmit: PropTypes.func,
};

DownloadForm.defaultProps = {
  additionalValidation: {},
  scene: "",
};

DownloadForm.contextTypes = {
  getData: PropTypes.func,
  intl: intlShape,
};

DownloadForm.childContextTypes = {
  scene: PropTypes.string,
};

function mapStateToProps(state, ownProps) {
  DOWNLOAD_VALIDATION_RULES = {
    ...DOWNLOAD_VALIDATION_RULES,
    ...ownProps.additionalValidation,
  };

  return {};
}

export default connect(mapStateToProps, null, null, { withRef: true })(
  reduxForm({
    form: "downloadForm",
    validate: (values) =>
      validationUtils.validate(values, DOWNLOAD_VALIDATION_RULES),
  })(DownloadForm)
);



// WEBPACK FOOTER //
// ./src/components/common/DownloadForm.js